export var defaultProps = {
    auto: true,
    className: '',
    direction: 'horizontal',
    gap: 0,
    height: 0,
    width: 0,
    reversible: false,
    speed: 0.5,
    style: {},
};
